import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAAAAAAAAgQEACJARAAkRUcAIkFAACVHSQADBwcAAAAAAAAAAAAADRkeADZmdwBAe5IAP3mJAD94iwASIicAAAAA3JEITNyei2AAAAAASUVORK5CYII="};
